import { LayoutTemplateIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/shared/ui/EmptyState';

/**
 * The sub-copy is passive on purpose: the panel has no Add control of its own,
 * so telling the reader to click one would point nowhere.
 */
export function BriefTemplatePreviewEmptyState() {
  const { t } = useTranslation('knowledge');

  return (
    <EmptyState
      data-testid="brief-template-preview-empty-state"
      icon={<LayoutTemplateIcon aria-hidden />}
      title={t('knowledgeHub.briefTemplatePreviewEmptyState.noBriefSectionsAddedYet')}
      description={t('knowledgeHub.briefTemplatePreviewEmptyState.sectionsWillAppearHereOnce')}
    />
  );
}
